import script from "./RightSideBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./RightSideBlock.vue?vue&type=script&lang=ts&setup=true"

import "./RightSideBlock.vue?vue&type=style&index=0&id=1bea0e45&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bea0e45"]])

export default __exports__